export default "__VITE_ASSET__MbYvtD1l__"